<template>
    <div class="cst-survey-card-finished">
        <h2> {{ $t('surveyAlreadyDone')}} </h2>
    </div>
</template>

<script>
    /* global eventHub */
    /* eslint no-undef: "error" */
    export default {
      created: function () {
        eventHub.$emit('set-title', this.$t('surveyFinishedTitle'))
      }
    }
</script>

<style lang="less" scoped>
    @import '../_theme';
    
    h2 {
        text-align: center;
        margin: 0;
        padding: 0;
    }
</style>




// WEBPACK FOOTER //
// src/components/CardSurveyDone.vue